import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#FFB8C8',
} as const

export const resources = {
  loginBg: '/images/storyella/login/login-bg.webp',
  logo: '',
  novel: '',
  facebookIcon: '/images/storyella/login/icon-facebook-logo.png',
  googleIcon: '/images/storyella/login/icon-google-logo.png',
  appleIcon: '/images/storyella/login/icon-apple-logo.png',
  emailIcon: '/images/storyella/login/icon-email.png',
  emailCodeIcon: '/images/storyella/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
